import { useCallback, useMemo, useState } from "react";
import SimpleTableTemplate from "@/components/Templates/SimpleTableTemplate";
import { useSelectableTableView } from "@/utils/tableHelpers";
import { createTaskColumns } from "@/views/Risk/Tasks/tasksTableConfig";
import TasksDrawer from "@/views/Risk/Tasks/TasksDrawer";
import { useHiddenTasks } from "@/views/Risk/Tasks/useHiddenTasks";
import AddActionModal from "./AddActionModal";
import type { TaskTableRow } from "@/views/Risk/Tasks/utils";

export default function Tasks() {
  const [addActionOpen, setAddActionOpen] = useState(false);
  const { taskRows, hideTask } = useHiddenTasks();
  const { selectedRecord, setSelectedRecord, getClickableRowProps } =
    useSelectableTableView<TaskTableRow>();
  const columns = useMemo(() => createTaskColumns(taskRows), [taskRows]);

  const handleRemoveTask = useCallback(
    (task_id: string) => {
      hideTask(task_id);
      setSelectedRecord(null);
    },
    [hideTask, setSelectedRecord],
  );

  return (
    <div className="flex w-full min-w-0 flex-col p-4">
      <SimpleTableTemplate
        title="Tasks"
        tooltipText="Review risk-related tasks, including linked issues, ownership, priority, due dates, and current status."
        fileName="tasks"
        data={taskRows}
        columns={columns}
        rowKey="task_id"
        onRow={getClickableRowProps}
        onAddRecord={() => setAddActionOpen(true)}
        addButtonLabel="+ Add task"
      />
      <TasksDrawer
        selectedRecord={selectedRecord}
        setSelectedRecord={setSelectedRecord}
        onRemove={handleRemoveTask}
      />
      <AddActionModal
        open={addActionOpen}
        onClose={() => setAddActionOpen(false)}
      />
    </div>
  );
}
